import { useTranslation } from 'react-i18next';
import moment from 'moment-timezone';

import {
  PlayTriangleIcon, CircleNotCheckRed, TriangleWarningIcon, ClockIcon,
} from 'icons';
import { colors } from 'styles/colors';

import {
  ResultIconWrap, ResultBody, ResultTitle, ResultDesc, BtnPrimary,
} from '../../styles';
import {
  NegativeWrap, NegativeHeader, NegativeDetailsLabel, ProblemBox, ProblemTitle, ProblemBody, NegativeFooter,
} from './styles';
import { getRuleTitleKey, getRuleCauseKey } from '../../helpers/ruleLabels';

interface FailureStateProps {
  failureReason: string | null;
  ruleTitle?: string | null;
  completedAt?: string | null;
  timezoneArea?: string | null;
  onRestartClick: () => void;
}

export const FailureState = ({
  failureReason, ruleTitle, completedAt, timezoneArea, onRestartClick,
}: FailureStateProps): JSX.Element => {
  const { t } = useTranslation();

  function formatCompletedLabel() {
    if (!completedAt) return '--';
    return (timezoneArea ? moment.tz(completedAt, timezoneArea) : moment(completedAt)).format('DD/MM/YYYY, HH:mm');
  }

  const completedLabel = formatCompletedLabel();
  const titleKey = getRuleTitleKey(ruleTitle);
  const causeKey = getRuleCauseKey(ruleTitle);
  const causeText = causeKey ? ` ${t('possiveisCausas')}: ${t(causeKey)}.` : '';

  return (
    <NegativeWrap>
      <NegativeHeader>
        <ResultIconWrap $variant="negative">
          <CircleNotCheckRed width={22} height={22} strokeWidth={1.2} />
        </ResultIconWrap>
        <ResultBody>
          <ResultTitle $variant="negative">{t('manutencaoInvalidaTitulo')}</ResultTitle>
          <ResultDesc>{t('manutencaoInvalidaDescricao')}</ResultDesc>
        </ResultBody>
        <BtnPrimary onClick={onRestartClick}>
          <PlayTriangleIcon color={colors.White} />
          {t('reiniciarValidacao')}
        </BtnPrimary>
      </NegativeHeader>
      <NegativeDetailsLabel>{t('problemaIdentificado')}</NegativeDetailsLabel>
      <ProblemBox>
        <TriangleWarningIcon color={colors.Red} size={16} />
        <div>
          <ProblemTitle>{t(titleKey)}</ProblemTitle>
          <ProblemBody>{`${failureReason ?? t('problemaDetectadoSemDetalhe')}${causeText}`}</ProblemBody>
        </div>
      </ProblemBox>
      <NegativeFooter>
        <ClockIcon size={12} color={colors.Grey300} />
        {t('validacaoConcluidaEmServico', {
          datetime: completedLabel,
          interpolation: { escapeValue: false },
        })}
      </NegativeFooter>
    </NegativeWrap>
  );
};
